module.exports = __webpack_public_path__ + "img/profil-picture.be5d1599.svg";